const path = "/remocao/data-distribuicao";
export default { main: path };
